export default "__VITE_ASSET__BaNRvWdW__"